var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconHeart = function SvgIconHeart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 19.638-1.21-1.093q-3.243-2.852-5.157-5.078T3.68 8.935q.038-1.953 1.328-3.242 1.29-1.29 3.242-1.328 1.095 0 2.07.469.976.468 1.68 1.25a5.35 5.35 0 0 1 1.68-1.25 4.7 4.7 0 0 1 2.07-.469q1.953.04 3.242 1.328 1.29 1.29 1.328 3.242-.039 2.305-1.953 4.532t-5.156 5.078z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconHeart);
export { ForwardRef as ReactComponent };